import { Expose, Transform, Type } from "class-transformer";
import { IsBoolean, IsDate, IsIn, IsMongoId, IsObject, IsOptional, IsString, ValidateNested } from "class-validator";

export class DriveItemDTO {
    @Transform(params => {
        return params.obj._id || params.obj.id;
    })
    @IsString()
    @Expose()
    id: string;

    @IsString()
    @Expose()
    name: string;

    @IsOptional()
    @IsString()
    @Expose()
    ext?: string;

    @IsIn(["folder", "file"])
    @IsString()
    @Expose()
	type: "folder" | "file";
	
    @Expose()
    @Type(() => DriveItemDTO)
    path?: DriveItemDTO[] = [];

    @Transform(({ key, obj }) => obj[key])
    @IsString()
    @Expose()
    parentID: string;

    @IsOptional()
    @Transform(({ key, obj }) => obj[key])
    @IsObject()
    @Expose()
	meta?: any;

    @IsDate()
    @Expose()
	created: Date
}